// extracted by css-extract-rspack-plugin
export default {"paperContainer":"src-domain-components-unblock-device-modal-UnblockDeviceModal-module__paperContainer-npUcAC","modalActions":"src-domain-components-unblock-device-modal-UnblockDeviceModal-module__modalActions-huEemD","customActionsClassName":"src-domain-components-unblock-device-modal-UnblockDeviceModal-module__customActionsClassName-XzWcN1"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"paperContainer\":\"src-domain-components-unblock-device-modal-UnblockDeviceModal-module__paperContainer-npUcAC\",\"modalActions\":\"src-domain-components-unblock-device-modal-UnblockDeviceModal-module__modalActions-huEemD\",\"customActionsClassName\":\"src-domain-components-unblock-device-modal-UnblockDeviceModal-module__customActionsClassName-XzWcN1\"}";
        // 1793705032608
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  